import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { HelperService } from '../../helper.service';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent {
  @Input() public label?: string;
  @Input() public form?: FormGroup;
  @Input() public abstractControl?: AbstractControl;
  @Input() public controlName?: string;
  @Input() public width = '100%';
  @Output() public change = new EventEmitter<string>();

  public toggle = false;

  constructor(public helper: HelperService) { }

  public onChange(color: string): void {
    if (this.form && this.controlName) {
      this.form?.patchValue({ [this.controlName]: color });
    }
    if (this.abstractControl && this.controlName) {
      this.abstractControl?.patchValue({ [this.controlName]: color });
    }
    this.change.emit(color);
  }
}
